var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"page-item",class:{
  'disabled' : _vm.disabled, 'active' : _vm.active,
  '__help-element': _vm.isMobile, '__icon-element': _vm.icon
}},[_c('a',{staticClass:"page-link",class:_vm.className,on:{"click":_vm.clickHandler}},[(_vm.icon)?_c('i',{class:_vm.icon}):[_vm._v(_vm._s(_vm.text))]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }